module.exports = __webpack_public_path__ + "img/unverifiedTick.fd2d081f.svg";